import { css, cx } from '@portal/styled-system/css'

import { Input, type InputProps } from '../view'

type EmailInputProps = Omit<InputProps, 'type' | 'name' | 'required' | 'autoFocus' | 'startDecorator'>

export function EmailInput(props: EmailInputProps) {
    return (
        <Input
            {...props}
            type="email"
            name="email"
            autoComplete={props.autoComplete ?? 'email'}
            required
            autoFocus
            startDecorator={
                <div
                    className={css({
                        width: '[2.375rem]',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    })}
                >
                    <i className={cx('fa-solid fa-envelope', css({ fontSize: 'md' }))} />
                </div>
            }
        />
    )
}
